export default "__VITE_ASSET__Dri1QMLg__"